const carousel = document.querySelector(".carousel");
const slides = document.querySelectorAll(".video_item");
const dots = document.querySelectorAll(".dot span");
const leftButton = document.querySelector("#prev");
const rightButton = document.querySelector("#next");
let currentIndex = 0;

function setCarouselHeight() {
  const video = document.querySelector(".video_item");
  const carousel = document.querySelector(".carousel");
  carousel.style.height = video.offsetHeight + "px";
}

// 初始化
setCarouselHeight();

// 监听窗口大小变化
window.addEventListener("resize", setCarouselHeight);

function updateVideo(index) {
  // 暂停所有视频
  slides.forEach((video) => video.pause());

  // 重置所有视频的播放进度
  slides.forEach((video) => (video.currentTime = 0));

  // 设置当前视频的透明度为1，其他视频的透明度为0
  slides.forEach((video, i) => {
    if (i === index) {
      video.style.opacity = 1;
      // 播放当前视频
      video.play();
    } else {
      video.style.opacity = 0;
    }
  });

  // 更新当前索引
  currentIndex = index;

  // 更新指示灯状态
  updateDots();
}

// 点击指示灯切换视频
function changeImage(index) {
  const currentvideo = carousel.querySelector(
    "video:nth-child(" + (currentIndex + 1) + ")"
  );
  const nextImg = carousel.querySelector(
    "video:nth-child(" + (index + 1) + ")"
  );

  currentvideo.style.opacity = 0;
  nextImg.style.opacity = 1;

  currentIndex = index;
}

let autoPlay = true; // 控制自动播放的变量
let intervalId; // 存储定时器的ID

function startAutoPlay() {
  intervalId = setInterval(() => {
    if (autoPlay) {
      // 切换到下一张图片
      currentIndex = (currentIndex + 1) % dots.length;
      changeImage(currentIndex);
      updateImg(currentIndex);
      updateVideo(currentIndex);
      dots.forEach((dot) => dot.classList.remove("active"));
      dots[currentIndex].classList.add("active");
    }
  }, 23000); // 每3秒切换一次图片
}

// 停止自动播放
function stopAutoPlay() {
  autoPlay = false;
  clearInterval(intervalId);
}

dots.forEach((dot, index) => {
  dot.addEventListener("click", () => {
    changeImage(index);
    updateVideo(index);
    setTimeout(setCarouselHeight, 0); // 切换视频时更新高度
    dots.forEach((dot) => dot.classList.remove("active"));
    dot.classList.add("active");
  });
});

// 为按钮添加事件监听器
document.getElementById("prev").addEventListener("click", function () {
  // 减少当前索引，如果到达第一张图片，则重置为最后一张图片的索引
  currentIndex = (currentIndex - 1 + dots.length) % dots.length;
  changeImage(currentIndex);
  updateVideo(currentIndex);
  updateDots();
  updateImg(currentIndex);
  stopAutoPlay(); // 停止自动播放
});

document.getElementById("next").addEventListener("click", function () {
  // 增加当前索引，如果到达最后一张图片，则重置为第一张图片的索引
  currentIndex = (currentIndex + 1) % dots.length;
  changeImage(currentIndex);
  updateVideo(currentIndex);
  updateDots();
  updateImg(currentIndex);
  stopAutoPlay(); // 停止自动播放
});

// 更新指示灯状态的函数
function updateDots() {
  dots.forEach((dot) => dot.classList.remove("active"));
  dots[currentIndex].classList.add("active");
}

// 更新轮播状态的函数
function updateImg(currentIndex) {
  slides.forEach((item) => (item.style.opacity = "0"));
  slides[currentIndex].style.opacity = "1";
}

// 为了防止自动播放在用户与轮播图交互时开始，我们需要在交互后重置自动播放
// carousel.addEventListener("mouseenter", () => {
//   stopAutoPlay();
// });

// carousel.addEventListener("mouseleave", () => {
//   startAutoPlay(); // 鼠标离开时重新开始自动播放
// });

// 初始化指示灯状态
updateDots();

// 启动自动播放
startAutoPlay();
